export class DeviceStatus {
    constructor(
        public status: any,
        public lastPing: any,
        public state: any,
    ) {
    }
}
